import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface AppointmentSlotRecord {
  id: string;
  startTime: string;
  endTime: string;
  isAvailable: boolean;
  medicalEstablishmentId: string;
  donorsPerSlot: number;
}

export const slotsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSlotsByMedicalEstablishment: builder.query<AppointmentSlotRecord[], string>({
      query: (medEstId) => `/slots/${medEstId}`,
      transformResponse: (res: ApiResponse<{ slots: AppointmentSlotRecord[] }>) => res.data.slots,
      providesTags: ["Slots"],
    }),
    createSlots: builder.mutation<AppointmentSlotRecord[], { medicalEstablishmentId: string; slots: Array<{ startTime: string; endTime: string; donorsPerSlot: number; isAvailable?: boolean }> }>({
      query: (body) => ({ url: "/slots", method: "POST", body }),
      transformResponse: (res: ApiResponse<{ slots: AppointmentSlotRecord[] }>) => res.data.slots,
      invalidatesTags: ["Slots"],
    }),
    deleteSlot: builder.mutation<void, string>({
      query: (id) => ({ url: `/slots/${id}`, method: "DELETE" }),
      invalidatesTags: ["Slots"],
    }),
  }),
});

export const { useGetSlotsByMedicalEstablishmentQuery, useCreateSlotsMutation, useDeleteSlotMutation } = slotsApi;
